import { Component } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
/**
 * Generated class for the TestComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'test',
  templateUrl: 'test.html'
})
export class TestComponent {

@Output() strokeAdded: EventEmitter<string> = new EventEmitter<string>();
  constructor() {
    console.log('Hello TestComponent Component');
    
  }

test(){
  this.strokeAdded.emit('strokeadded');
  console.log('after test and emit strokeadded');
}

}



// WEBPACK FOOTER //
// ./src/components/test/test.ts